export default __webpack_public_path__ + "static/media/loader-tab.5dba6591.png";